// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"25feac4d","117":"a2c88231","268":"234acb6f","752":"382fc036","883":"4c61e74d","932":"400c8337"}[chunkId] + ".chunk.js";
};